import React, { createContext, FC, useCallback, useContext, useState } from 'react';

interface PdqProps {
  waiterId: string | null;
  setWaiterId: React.Dispatch<React.SetStateAction<string | null>>;
  resetWaiterId: () => void;
}

const useValue = (): PdqProps => {
  const [waiterId, setWaiterId] = useState<PdqProps['waiterId']>(null);

  const resetWaiterId = useCallback(() => {
    setWaiterId(null);
  }, [setWaiterId]);

  return {
    waiterId,
    setWaiterId,
    resetWaiterId,
  };
};

const PdqContext = createContext<PdqProps>({} as PdqProps);

export const usePdq = () => useContext<PdqProps>(PdqContext);

const PdqProvider: FC = ({ children }) => (
  <PdqContext.Provider value={useValue()}>{children}</PdqContext.Provider>
);

export default PdqProvider;
